import { render, staticRenderFns } from "./BotManage.vue?vue&type=template&id=48f03078&scoped=true&"
import script from "./BotManage.vue?vue&type=script&lang=js&"
export * from "./BotManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f03078",
  null
  
)

export default component.exports